import gql from 'graphql-tag'

export const GET_BOOKING_POSSIBILITIES = gql`
  query GetBookingPossibilities(
    $StartDateTime: String!
    $EndDateTime: String!
    $ProgramId: String!
    $InstructorId: String!
  ) {
    getBookingPossibilities(
      StartDateTime: $StartDateTime
      EndDateTime: $EndDateTime
      ProgramId: $ProgramId
      InstructorId: $InstructorId
    ) {
      bookingPossibilitiesDateRange {
        StartDateTime
        EndDateTime
      }
    }
  }
`
